import { getParameterByName, Base64 } from './util';

const initPrefillForms = function initPrefillForms()
{
  const encodedData = getParameterByName('form-data'); 

  if (encodedData) {
    // Decode from URL encoding
    const base64 = decodeURIComponent(encodedData);
    const decoded = Base64.decode(base64);
    const parsedData = JSON.parse(decoded);

    // Populate inputs
    Object.keys(parsedData).forEach(key => {
      const input = document.getElementById(key);
      if (input) {
        input.value = parsedData[key];
    
        var event = new Event('change', {
          'bubbles': true,
          'cancelable': true
        });
    
        input.dispatchEvent(event);
      }
    });
  }
}

function prepareFormsUrl( paramsObj ) {
  const jsonString = JSON.stringify(paramsObj);
  const base64Encoded = Base64.encode(jsonString);
  return encodeURIComponent(base64Encoded);
}

function strapsContactBtn() {
  const btn = document.getElementById('strapsContactBtn');

  if(!btn) return;

  btn.addEventListener('click', () => {
    const locale = document.querySelector('.watch__keyfacts').dataset.locale;
    const strapName = document.querySelector('#straps-slider .swiper-slide-active h4').innerHTML;
    const standardStrapName = document.querySelector('.standard-strap').innerHTML;

    const watchName = btn.dataset.watchName;

    let message = `Dear Sir or Madam,\nI am interested in the model ${watchName} with the standard strap ${standardStrapName}\nI am also interested in ${strapName}\nI look forward to your feedback.\nYours sincerely,`;

    if(locale === 'de') {
      message = `Sehr geehrte Damen und Herren,\nich interessiere mich für das Modell ${watchName} mit dem Standardarmband ${standardStrapName}\nAls weitere Bandvariante interessiert mich ${strapName}\nIch freue mich auf Ihre Rückmeldung.\nMit freundlichen Grüßen,`;
    }

    if(locale === 'it') {
      message = `Gentile Signore o Signora,\nSono interessato al modello ${watchName} con il cinturino standard ${standardStrapName}\nSono anche interessato a ${strapName}\nRimango in attesa di un vostro riscontro.\nCordiali saluti,`;
    }

    if(locale === 'es') {
      message = `Estimado señor o señora\nEstoy interesado en el modelo ${watchName} con la correa estándar ${standardStrapName}\nTambién estoy interesado en ${strapName}\nEspero sus comentarios.\nAtentamente,`;
    }

    if(locale === 'fr') {
      message = `Madame, Monsieur\nJe suis intéressé par le modèle ${watchName} avec le bracelet standard ${standardStrapName}\nJe suis également intéressé par ${strapName}\nJ'attends avec impatience vos commentaires.\nMeilleures salutations,`;
    }

    if(locale === 'kr') {
      message = `친애하는 선생님 또는 부인,\n표준 스트랩이 ${watchName} 인 ${standardStrapName} 모델에 관심이 있습니다\n또한 ${strapName} 에도 관심이 있습니다\n여러분의 의견을 기다리겠습니다.\n진심으로 감사드립니다,`;
    }

    if(locale === 'ja') {
      message = `拝啓,\n標準ストラップ ${watchName} 付きのモデル ${standardStrapName} に興味があります。\nまた、${strapName} にも興味があります。\nご意見をお待ちしております。\n敬具`;
    }
 
    if(locale === 'zh' || locale === 'zt') {
      message = `尊敬的先生或女士,\n我对标准表带 ${watchName} 的型号 ${standardStrapName} 感兴趣。\n我还对 ${strapName} 感兴趣。\n期待您的反馈。\n此致敬礼、`;
    }

    const formData = {
      form_id: 20,
      step: 2,
      input_20_1: 'PRODUCT',
      input_20_12: message
    }

    const url = btn.dataset.contactPage + '?form-data=' + prepareFormsUrl(formData) + '#gform_wrapper_20';

    window.location.href = url;
  });
}

function appointmentContactBtn() {
 const btn = document.getElementById('appointmentContactBtn');

 if(!btn) return;

 btn.addEventListener('click', () => {
   const watchName = btn.dataset.watchName;
   let message = watchName;

   const formData = {
     form_id: 23,
     input_23_23: message
   }

   const url = btn.dataset.contactPage + '?form-data=' + prepareFormsUrl(formData) + '#gform_wrapper_23';

   window.location.href = url;
 });
}

export { initPrefillForms, strapsContactBtn, appointmentContactBtn };